/**
 * @file routes/_app/me/storage.tsx
 * @description 離線存儲 / 同步管理頁面（需認證，在線後台）。
 *
 * 功能：
 * - 顯示當前設備指紋與持久化存儲狀態（可一鍵啟用）
 * - 顯示同步狀態（在線/離線、待同步條目、上次同步時間）
 * - 提供手動全量同步、本地備份導出、設備釋放功能
 * - 列出已下載任務包（可刪除本地離線包）
 * - iOS 用戶 PWA 安裝提醒（防止 Safari 7 天自動清理 IndexedDB）
 *
 * 與 `(public)/me/offline.tsx` 的區別：
 * - 本頁是「在線管理」入口，需登入、套完整後台殼（側邊欄/頭部）；
 * - `/me/offline` 是「離線現場」入口，公開、極簡、零後端依賴。
 */

import { createFileRoute } from '@tanstack/react-router';
import { WifiOff } from 'lucide-react';
import { OfflineManagementPage } from '@/components/notifications/OfflineManagementPage';
import { PageShell } from '@/components/shell';

/** 路由定義 */
export const Route = createFileRoute('/_app/me/storage')({ component: StorageManagementPage });

/**
 * 離線存儲管理路由頁。
 * 包裝 OfflineManagementPage 並補充 PageShell header。
 */
function StorageManagementPage() {
  return (
    <PageShell
      title={
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <WifiOff size={24} />
          離線存儲管理
        </span>
      }
      description="管理本機離線資料、同步狀態與設備存儲配額"
    >
      <OfflineManagementPage />
    </PageShell>
  );
}
